import { valueToCollabJSON } from '@databases/collab/convert/to-collab';
import { setValueValue } from '@databases/collab/y-database';
import { type MutableDatabase } from '@databases/model/database';
import { DEFAULT_ENTRY_ID } from '@databases/types/database';

export class ValueAgent {
  private database: MutableDatabase;

  constructor(database: MutableDatabase) {
    this.database = database;
  }

  public setValue(
    entryId: string,
    fieldId: string,
    value: any,
    resetValue = false
  ): void {
    this.database.mutate((db) => {
      const entry =
        entryId === DEFAULT_ENTRY_ID ? db.defaultEntry : db.entriesById[entryId];
      if (!entry) {
        throw new Error(`Entry with ID ${entryId} not found`);
      }

      const field = db.fieldsById[fieldId];
      if (!field) {
        throw new Error(`Field with ID ${fieldId} not found`);
      }

      if (resetValue) {
        entry.removeValue(fieldId);
      }

      const mutableValue = entry.setValue(fieldId, field.type);

      const valueJson = valueToCollabJSON(value, {});

      if (valueJson) {
        setValueValue(mutableValue, valueJson);
      }
    });
  }
}
